import { bluePalette } from '../../themes/colors';

export const scrollSnappingLightThemeV2 = {
  padding: '32px',
  backgroundColor: bluePalette[200],
};
